import VcSvg from "../src/components/VcSvg/VcSvg.vue";
import icons from "./SvgIcons";

export const reducer = (acc, key, obj = icons) => {
    acc[key] = {
        component: VcSvg,
        props: {svg: obj[key]}
    };
    return acc;
}
const iconsArray = Object.keys(icons).reduce((acc, key) => reducer(acc, key), {});

export default {
    icons: {
        iconfont: "md",
        rtl: false,
        values: iconsArray
    },
    theme: {
        dark: false,
        options: {
            customProperties: true // allow create css variables based on the theme
        },
        themes: {
            light: {
                primary: '#0C315E', // represents the secondary color on DB
                secondary: { // represents the primary color on DB
                    base: '#0093B8',
                    lighten1: '#99D4E3',
                    lighten2: '#C2E5EE',
                    lighten3: '#EDF7FA'
                },
            }
        }
    }
}
